import { initializeApp } from 'firebase/app';
import { firebaseConfig } from '../config';
import { getStorage } from 'firebase/storage';
import { initializeFirestore } from 'firebase/firestore';

const firebaseApp = initializeApp(firebaseConfig);

const firestore = initializeFirestore(firebaseApp, {
    experimentalForceLongPolling: true,
    ignoreUndefinedProperties: true,
});
const storage = getStorage(firebaseApp);

// Get a reference to the storage service, which is used to create references in your storage bucket

export { firebaseApp, firestore, storage };
